import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from 'api/Api';
import { MessageTypeEnum } from 'api/MessagesApi';

interface MessageDataResponse {
  title: string;
  content: string;
}

interface GenerateMessageRequest {
  type: MessageTypeEnum;
  eventType: string;
  recipients: {
    name: string;
    relationship: string;
  }[];
  tones: string[];
  emotionFocus?: string;
  memory?: string;
  closing?: string;
  otherInfo?: string;
}

interface GenerateMessageWithInstructionsRequest extends GenerateMessageRequest {
  draftText: string;
  instructions: string;
}

interface SuggestPromptsRequest {
  type: MessageTypeEnum;
  tones?: string[];
  recipientName?: string;
  recipientRelationship?: string;
  eventType?: string;
  slot?: string;
  initialInput?: string;
}

interface SuggestPrompt {
  question: string;
  sentences: string[];
}

export const messageAiApi = createApi({
  baseQuery: baseQueryWithReAuth,
  reducerPath: 'messageAiApi',
  endpoints: (build) => ({
    generateMessage: build.mutation<MessageDataResponse, GenerateMessageRequest>({
      query: (body) => ({
        url: '/message/ai/generate',
        method: 'POST',
        body
      }),
      transformResponse: (response: { data: MessageDataResponse }) => response.data
    }),
    regenerateWithInstructionsMessage: build.mutation<MessageDataResponse, GenerateMessageWithInstructionsRequest>({
      query: (body) => ({
        url: '/message/ai/regenerate-with-instructions',
        method: 'POST',
        body
      }),
      transformResponse: (response: { data: MessageDataResponse }) => response.data
    }),
    suggestPrompts: build.mutation<SuggestPrompt, SuggestPromptsRequest>({
      query: (body) => ({
        url: '/message/ai/suggest-prompts',
        method: 'POST',
        body
      }),
      transformResponse: (response: { data: SuggestPrompt }) => response.data
    })
  })
});

export const { useGenerateMessageMutation, useRegenerateWithInstructionsMessageMutation, useSuggestPromptsMutation } =
  messageAiApi;
